import { Button, Icons, Label } from "@sede-x/shell-ds-react-framework";
import { useState } from "react";
import { TMovement } from "ticketing/ticketing.types";
import {
  TEMPERATURE_MEASURE_NAME,
  equalsIgnoreCase,
  formatNumber,
  mapTempUOM
} from "ticketing/utils";
import RevisionsMovement from "./RevisionsMovement";

export const MovementChildHeader = ({
  childMovement
}: {
  childMovement: Partial<TMovement>;
}) => {
  const [showNomRevisions, setShowNomRevisions] = useState(false);
  const scheduledQuantity = childMovement?.scheduledQuantity ?? 0;
  const actualizedQuantity = childMovement.actualizedQuantity ?? 0;
  const remainingQuantityMax = Math.max(0, scheduledQuantity - actualizedQuantity);
  const temperatureMeasure = childMovement.measures?.find(measure =>
    equalsIgnoreCase(measure.measurementType.name, TEMPERATURE_MEASURE_NAME)
  );

  const temperatureData = `${temperatureMeasure?.value ?? "?"} ${mapTempUOM(
    temperatureMeasure?.unitOfMeasure?.name ?? "?"
  )?.charAt(0)}`;

  return (
    <div className="movement-group-header-container">
      <div style={{ display: "flex" }}>
        <div className="delivery-id-label-container" key={`${childMovement.id}`}>
          <span role="none" style={{ borderRadius: "0", userSelect: "none" }}>
            {`${childMovement.enterpriseSystemCode} ${childMovement.internalLegalEntity?.name}`}
          </span>
          <Button
            iconPosition="right"
            icon={<Icons.CopyFile className="copy-btn" />}
            className="delivery-id-copy-button"
            size="small"
            onClick={e => {
              navigator.clipboard.writeText(childMovement.enterpriseSystemCode ?? "");
              e.stopPropagation();
            }}
          />
        </div>
      </div>

      <div className="movement-group-label-container">
        <Label>
          <span>{"Scheduled: "}</span>
          <span style={{ color: "var(--primary-icon-color)" }}>
            {formatNumber(scheduledQuantity)}
          </span>
        </Label>

        <Label>
          <span>{"Actualized: "}</span>
          <span style={{ color: "limegreen" }}>{formatNumber(actualizedQuantity)}</span>
        </Label>

        {/* 1477660 - if actualization complete is true hide the remaining quantity */}
        {!childMovement?.actualizationComplete && (
          <Label>
            <span>{"Remaining: "}</span>
            <span style={{ color: "orangered" }}>{formatNumber(remainingQuantityMax)}</span>
          </Label>
        )}
        <Label>{childMovement.unitOfMeasure?.name}</Label>
        <Label>{temperatureData}</Label>
        <Label style={{ textDecoration: "underline", textTransform: "uppercase" }}>
          {childMovement.status?.name}
        </Label>
      </div>
      <div style={{ display: "flex" }}>
        {showNomRevisions && (
          <RevisionsMovement
            onClose={() => setShowNomRevisions(false)}
            enterpriseSystemCode={childMovement.enterpriseSystemCode!}
            movementId={childMovement.id!}></RevisionsMovement>
        )}
        <Button
          iconPosition="right"
          fullWidth={true}
          title="Movement Revisions"
          size="small"
          icon={<Icons.Time style={{ fill: "var(--primary-icon-color)" }} />}
          variant="transparent"
          onClick={() => setShowNomRevisions(true)}></Button>
      </div>
    </div>
  );
};
